<mat-toolbar color="primary" *ngIf="nav$ | async as nav">
  <mat-toolbar-row class="d-none d-sm-flex nav">
    <a class="home-link me-3 d-inline-block" routerLink="/">{{ adminTitle }}</a>
    <a class="nav-link d-inline-block" routerLink="/users"
      [routerLinkActive]="['is-active']">Users</a>
    <a *ngIf="nav.reportedUsers" class="nav-link d-inline-block" routerLink="/reported-users"
      [routerLinkActive]="['is-active']">Reported Users</a>
    <a *ngIf="nav.bannedUsers" class="nav-link d-inline-block" routerLink="/banned-users"
      [routerLinkActive]="['is-active']">Banned Users</a>
    <a *ngIf="nav.underReviewUsers" class="nav-link d-inline-block" routerLink="/under-review-users"
      [routerLinkActive]="['is-active']">Under Review Users</a>
    <a *ngIf="nav.silentHiddenUsers" class="nav-link d-inline-block" routerLink="/silent-hidden-users"
      [routerLinkActive]="['is-active']">Silent Hidden Users</a>
    <a *ngIf="nav.suspiciousUsers" class="nav-link d-inline-block" routerLink="/suspicious-users"
      [routerLinkActive]="['is-active']">Suspicious Users</a>
    <a *ngIf="nav.messageFlags" class="nav-link d-inline-block" routerLink="/message-flags"
      [routerLinkActive]="['is-active']">Message Flags</a>
    <a *ngIf="nav.matches" class="nav-link d-inline-block" routerLink="/matches"
      [routerLinkActive]="['is-active']">Matches</a>
    <a *ngIf="nav.prompts" class="nav-link d-inline-block" routerLink="/prompts"
      [routerLinkActive]="['is-active']">Prompts</a>
    <a *ngIf="nav.blockAllow" class="nav-link d-inline-block" routerLink="/block-allow"
      [routerLinkActive]="['is-active']">Block/Allow</a>
    <a *ngIf="nav.algorithm" class="nav-link d-inline-block" routerLink="/algorithm"
      [routerLinkActive]="['is-active']">Algorithm</a>
    <a *ngIf="nav.verifications" class="nav-link d-inline-block" routerLink="/verifications"
      [routerLinkActive]="['is-active']">Verifications</a>
    <a *ngIf="nav.analytics" class="nav-link d-inline-block" routerLink="/analytics"
      [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['is-active']">Analytics</a>
    <a *ngIf="nav.tools" class="nav-link d-inline-block" routerLink="/tools"
      [routerLinkActive]="['is-active']">Tools</a>
  </mat-toolbar-row>

  <mat-toolbar-row class="d-sm-none d-flex align-items-center w-100">
    <span>{{ adminTitle }}</span>
    <span class="spacer"></span>

    <button mat-icon-button
      [matMenuTriggerFor]="menu"><mat-icon>menu</mat-icon></button>
    <mat-menu #menu="matMenu">
      <button routerLink="/users" [routerLinkActive]="['is-active']"
        mat-menu-item>Users</button>
      <button *ngIf="nav.reportedUsers" routerLink="/reported-users" [routerLinkActive]="['is-active']"
        mat-menu-item>Reported Users</button>
      <button *ngIf="nav.bannedUsers" routerLink="/banned-users" [routerLinkActive]="['is-active']"
        mat-menu-item>Banned Users</button>
      <button *ngIf="nav.underReviewUsers" routerLink="/under-review-users"
        [routerLinkActive]="['is-active']" mat-menu-item>Under Review
        Users</button>
      <button *ngIf="nav.silentHiddenUsers" routerLink="/silent-hidden-users"
        [routerLinkActive]="['is-active']" mat-menu-item>Silent Hidden
        Users</button>
      <button *ngIf="nav.suspiciousUsers" routerLink="/suspicious-users" [routerLinkActive]="['is-active']"
        mat-menu-item>Suspicious Users</button>
      <button *ngIf="nav.messageFlags" routerLink="/message-flags" [routerLinkActive]="['is-active']"
        mat-menu-item>Message Flags</button>
      <button *ngIf="nav.matches" routerLink="/matches" [routerLinkActive]="['is-active']"
        mat-menu-item>Matches</button>
      <button *ngIf="nav.prompts" routerLink="/prompts" [routerLinkActive]="['is-active']"
        mat-menu-item>Prompts</button>
      <button *ngIf="nav.blockAllow" routerLink="/block-allow" [routerLinkActive]="['is-active']"
        mat-menu-item>Block/Allow</button>
      <button *ngIf="nav.algorithm" routerLink="/algorithm" [routerLinkActive]="['is-active']"
        mat-menu-item>Algorithm</button>
      <button *ngIf="nav.verifications" routerLink="/verifications"
        [routerLinkActive]="['is-active']" mat-menu-item>Verifications</button>
      <button *ngIf="nav.analytics" routerLink="/analytics" [routerLinkActive]="['is-active']"
        [routerLinkActiveOptions]="{ exact: true }" mat-menu-item>Analytics</button>
      <button *ngIf="nav.tools" routerLink="/tools" [routerLinkActive]="['is-active']"
        mat-menu-item>Tools</button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
